import cn from 'classnames';

import { selectMerchandisingBannerDetails } from '@/features/promoBanners/selectors';
import { useAppSelector } from '@/store';

import styles from './PromoMessage.module.scss';

export const PromoMessage = ({ className }: { className?: string }) => {
  const { sailingItemText } = useAppSelector(selectMerchandisingBannerDetails) || {};
  if (!sailingItemText) {
    return;
  }
  return <div className={cn(styles.promoDiscount, className)}>{sailingItemText}</div>;
};
